import { CardStatusIncidenceDto, OptionStatusDto, RowStatusDto } from "@/dtos";
import { Incidence, Status } from "@/entities";

export const formatRowStatusDto = (statuses: Status[]): RowStatusDto[] => {
    return statuses.map(x => {
        const row: RowStatusDto = {
            ...x,
            is_completed_label: x.is_completed ? 'Si' : 'No',
            active: x.is_active ? 'Activo' : 'Inactivo'
        }

        return row;
    });
}

export const formatCardStatusIncidence = (statusList: Status[], incidences: Incidence[]): CardStatusIncidenceDto[] => {
    const result = [] as CardStatusIncidenceDto[];
    for (const status of statusList) {
        const incidencesStatus = incidences.filter(i => i.incidence_status[0].status?.id == status.id); 
        const card: CardStatusIncidenceDto = {
            status_id: status.id,
            status: status.name,
            color: status.color,
            colorText: status.text_color,
            incidences: incidencesStatus
        }

        result.push(card);
    }

    return result;
}

export const formatStatusOption = (statusList: Status[]): OptionStatusDto[] => {
    return statusList.map(x => {
        const opt: OptionStatusDto = {
            label: x.name,
            value: x.id,
            is_completed: x.is_completed
        }

        return opt;
    });
}